<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary">business</v-icon> {{ $t('pago.title') }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :order="order"
          :graphql="graphql"
          :data-graphql="dataGraphql"
        >
          <template slot="items" slot-scope="items">
            <td>
              <v-chip label color="error" text-color="white" v-if="items.item.estado == 'PENDIENTE'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'HABILITADO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="info" text-color="white" v-if="items.item.estado == 'PAGADO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
            <td>
              <v-chip label color="warning" text-color="white" v-if="items.item.tipo == 'ENTIDAD'">
                {{ items.item.tipo }}
              </v-chip>
              <v-chip label color="info" text-color="white" v-if="items.item.tipo == 'CANCILLERIA'">
                {{ items.item.tipo }}
              </v-chip>
            </td>
            <td>{{ items.item.titular_factura }}</td>
            <td>{{ items.item.nro_documento }}</td>

            <td>
            <span v-for="(value, key) in items.item.cpt">
                  <span v-if="key==='cpt'">
                    {{value}}
                  </span>
              </span>
            </td>

            <td>{{ items.item.id_tramite_doc }}</td>
            <td>{{ $datetime.format(items.item._created_at, 'dd/MM/YYYY hrs. HH:mm') }}</td>
            <td>{{ $datetime.format(items.item.fecha_pago, 'dd/MM/YYYY hrs. HH:mm') }}</td>


          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';

export default {
  mixins: [ crud ],
  data () {
    return {
      graphql: true,
      url: 'pagos',
      headers: [
        { text: this.$t('pago.crud.estado'), value: 'estado' },
        { text: this.$t('pago.crud.tipo'), value: 'tipo' },
        { text: this.$t('pago.crud.titular_factura'), value: 'titular_factura' },
        { text: this.$t('pago.crud.nro_documento'), value: 'nro_documento' },
        { text: this.$t('pago.crud.cpt'), value: 'id' },
        { text: 'Nro. Tramite', value: 'id_tramite_doc' },
        { text: 'Fecha de autorización - Pago', value: '_created_at' },
        { text: this.$t('pago.crud.fecha_pago'), value: 'fecha_pago' }
      ],
      order: ['_created_at', 'DESC'],
      dataGraphql: `
        id
        id_tramite_doc
        cpt
        tipo
        estado
        fecha_pago
        _created_at
        nro_documento
        titular_factura
      `,
      filters: [
        {
          field: 'cpt',
          label: this.$t('pago.crud.cpt'),
          type: 'text',
          typeG: 'JSON'
        },
        {
          field: 'nro_documento',
          label: this.$t('pago.crud.nro_documento'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'fecha_pago',
          label: this.$t('pago.crud.fecha_pago'),
          type: 'text',
          typeG: 'Date'
        },
        {
          field: 'titular_factura',
          label: this.$t('pago.crud.titular_factura'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'tipo',
          label: this.$t('pago.crud.tipo'),
          type: 'select',
          typeG: 'TipoPago',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'ENTIDAD', text: 'ENTIDAD' },
            { value: 'CANCILLERIA', text: 'CANCILLERIA' }
          ]
        },
        {
          field: 'estado',
          label: this.$t('pago.crud.estado'),
          type: 'select',
          typeG: 'EstadoPago',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'PENDIENTE', text: 'PENDIENTE' },
            { value: 'HABILITADO', text: 'HABILITADO' },
            { value: 'PAGADO', text: 'PAGADO' }
          ]
        }
      ]
    };
  },
  components: {
    CrudTable
  }
};
</script>



// WEBPACK FOOTER //
// Pago.vue?0f234c12